import React from 'react';
import { Typography, Grid, TextField, Stack } from '@mui/material';
import { Controller } from 'react-hook-form';

/**
 * Reusable organisation form fields.
 *
 * Props:
 *  - control  – react-hook-form control object
 *  - errors   – react-hook-form errors object
 */
const OrganisationForm = ({ control, errors }) => {
  return (
    <Stack spacing={2}>
      <Controller
        name="name"
        control={control}
        render={({ field }) => (
          <TextField {...field} label="Organisation Name *" fullWidth error={!!errors.name} helperText={errors.name?.message} />
        )}
      />
      <Controller
        name="abn"
        control={control}
        render={({ field }) => (
          <TextField {...field} label="ABN" fullWidth error={!!errors.abn} helperText={errors.abn?.message} />
        )}
      />
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <Controller
            name="email"
            control={control}
            render={({ field }) => (
              <TextField {...field} label="Email" fullWidth error={!!errors.email} helperText={errors.email?.message} />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <Controller
            name="phone"
            control={control}
            render={({ field }) => (
              <TextField {...field} label="Phone" fullWidth error={!!errors.phone} helperText={errors.phone?.message} />
            )}
          />
        </Grid>
      </Grid>
      <Controller
        name="contactPerson"
        control={control}
        render={({ field }) => (
          <TextField {...field} label="Contact Person" fullWidth />
        )}
      />
      <Typography variant="subtitle2" color="text.secondary" mt={1}>Address</Typography>
      <Controller
        name="address.street"
        control={control}
        render={({ field }) => <TextField {...field} label="Street" fullWidth size="small" />}
      />
      <Grid container spacing={2}>
        <Grid size={{ xs: 6 }}>
          <Controller
            name="address.city"
            control={control}
            render={({ field }) => <TextField {...field} label="City" fullWidth size="small" />}
          />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <Controller
            name="address.state"
            control={control}
            render={({ field }) => <TextField {...field} label="State" fullWidth size="small" />}
          />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <Controller
            name="address.postcode"
            control={control}
            render={({ field }) => <TextField {...field} label="Postcode" fullWidth size="small" />}
          />
        </Grid>
      </Grid>
    </Stack>
  );
};

export default OrganisationForm;
